import React, { Component } from 'react'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/magnific-popup.css'
import './home/css/styles.css'

import "bootstrap/dist/css/bootstrap.min.css"

class Navbar extends Component {
  render() {
    return (
      <div>
        {/* FOOTER */}
        <div className="footer">
          <div className="row footerRow">
            <div className="text-container about">
              <h4>Tickets across the country</h4>
              <p className="white">SeatStir serves more
              than 25 U.S. markets coast to coast. Our cities currently
              include Philadelphia, PA - Washington D.C. / Baltimore MD
              - Pittsburgh, PA - Cleveland, OH - Northern New Jersey &
                  NYC - and Minneapolis / St. Paul, MN.</p>
              <div className="text-container footerCont">
                <h4 className="footExtras"><a href="/terms-conditions"> Terms & Conditions</a></h4>
                <h4 className="footExtras"><a href="/rules">Privacy Policy</a></h4>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <p className="p-small">Copyright © 2020 Built by Logan Gayler</p>
              </div>
            </div>
          </div>
        </div>


      </div>
    )
  }
}

export default Navbar